export const multiTenantActions = [
  {
    name: 'addNewUserToTenant',
    label: 'Add New / Existing User to Tenant',
    args: [
      {
        name: 'userRole',
        label: 'Select User Role',
        type: 'dropdown',
        optionsType: 'userRoleApi',
        options: [],
        value: '',
      },
      {
        name: 'userSettings',
        label: 'Add User Settings',
        type: 'boolean',
        value: '',
        custom: [],
      },
      {
        name: 'confirmationMessage',
        label: 'Alert Message',
        type: 'text',
        value: '',
        optional: true,
      },
      {
        name: 'successMessage',
        label: 'Success Message (Optional)',
        type: 'text',
        value: '',
        optional: true,
      },
      {
        name: 'errorMessage',
        label: 'Error Message (Optional)',
        type: 'text',
        value: '',
        optional: true,
      },
      {
        name: 'passPreviousActionFormData',
        label: 'Save Form Submission Data In Browser Storage',
        type: 'boolean',
        value: '',
      },
      {
        name: 'formDataSessionKey',
        label: 'Form Data Session Key',
        type: 'text',
        value: '',
      },
      {
        name: 'formDataBrowserStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'passPreviousActionResponse',
        label: 'Save Response Data In Browser Storage',
        type: 'boolean',
        value: '',
      },
      {
        name: 'responseDataSessionKey',
        label: 'Response Data Session Key',
        type: 'text',
        value: '',
      },
      {
        name: 'responseDataSessionStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
    ],
  },
  {
    name: 'removeUserFromTenant',
    label: 'Remove User from Tenant',
    args: [
      {
        name: 'confirmationMessage',
        label: 'Alert Message',
        type: 'text',
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message (Optional)',
        type: 'text',
        value: '',
        optional: true,
      },
      {
        name: 'errorMessage',
        label: 'Error Message (Optional)',
        type: 'text',
        value: '',
        optional: true,
      },
    ],
  },
  {
    name: 'switchUserTenant',
    label: 'Switch Tenant',
    args: [
      {
        name: 'confirmationMessage',
        label: 'Alert Message',
        type: 'text',
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message (Optional)',
        type: 'text',
        value: '',
        optional: true,
      },
      {
        name: 'errorMessage',
        label: 'Error Message (Optional)',
        type: 'text',
        value: '',
        optional: true,
      },
      {
        name: 'skipPageReload',
        label: 'Skip Page Reload',
        type: 'boolean',
        value: true,
        custom: [],
      },
    ],
  },
  {
    name: 'switchSubTenant',
    label: 'Switch Sub Tenant',
    args: [
      {
        name: 'confirmationMessage',
        label: 'Alert Message',
        type: 'text',
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message (Optional)',
        type: 'text',
        value: '',
        optional: true,
      },
      {
        name: 'errorMessage',
        label: 'Error Message (Optional)',
        type: 'text',
        value: '',
        optional: true,
      },
      {
        name: 'skipPageReload',
        label: 'Skip Page Reload',
        type: 'boolean',
        value: true,
        custom: [],
      },
    ],
  },
  {
    name: 'updateCurrentTenantData',
    label: 'Update Current Tenant',
    args: [
      {
        name: 'constructor',
        label: 'Constructor (Optional)',
        type: 'dropdown',
        optionsType: 'tenantConstructorApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message (Optional)',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message (Optional)',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'updateCurrentUserSettingData',
    label: 'Update Current User Setting',
    args: [
      {
        name: 'constructor',
        label: 'Constructor (Optional)',
        type: 'dropdown',
        optionsType: 'tenantConstructorApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message (Optional)',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message (Optional)',
        type: 'text',
        value: '',
      },
    ],
  },
];
